// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Mkou","left":"styles_left__3UmRA","desktopActions":"styles_desktopActions__Pnd-x","title":"styles_title__37kwo"};